// Accept both the legacy JWT-decoded shape ({ _doc: user }) and the safe user
// object returned by the cookie-session login/refresh endpoints.
export const getAuthUser = (auth) => auth?._doc || auth || null;

export const getUserPermissions = (auth) => getAuthUser(auth)?.permissions || {};

export const normalizeSessionType = (sessionType) => {
  if (sessionType === "org" || sessionType === "organization") return "org";
  if (sessionType === "centre" || sessionType === "center") return "centre";
  if (sessionType === "doctor") return "doctor";
  if (sessionType === "user") return "user";
  return null;
};

export const getSessionType = (auth) =>
  normalizeSessionType(auth?.sessionType || sessionStorage.getItem("litss_session_type"));

export const normalizeAuthIdentity = (identity, sessionType) => {
  const user = getAuthUser(identity);
  if (!user) return null;

  const resolvedSessionType = normalizeSessionType(sessionType || identity.sessionType);
  if (resolvedSessionType) {
    sessionStorage.setItem("litss_session_type", resolvedSessionType);
  }

  return {
    ...identity,
    ...user,
    _doc: user,
    permissions: user.permissions || identity.permissions || {},
    sessionType: resolvedSessionType,
    isDoctorSession: resolvedSessionType === "doctor",
  };
};

export const isPermission = (permission) => permission === true;
